import { render, staticRenderFns } from "./SeminarSidebar.vue?vue&type=template&id=0b1e11ec"
import script from "./SeminarSidebar.vue?vue&type=script&lang=js"
export * from "./SeminarSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports